import { render, staticRenderFns } from "./UserBadge.vue?vue&type=template&id=18421891"
import script from "./UserBadge.vue?vue&type=script&lang=js"
export * from "./UserBadge.vue?vue&type=script&lang=js"
import style0 from "./UserBadge.vue?vue&type=style&index=0&id=18421891&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18421891')) {
      api.createRecord('18421891', component.options)
    } else {
      api.reload('18421891', component.options)
    }
    module.hot.accept("./UserBadge.vue?vue&type=template&id=18421891", function () {
      api.rerender('18421891', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/components/UserBadge.vue"
export default component.exports